import { generalFreightOrder } from "./generalFreightOrder";

const containerTransportOrder = {
	...generalFreightOrder
};

export { containerTransportOrder };
